import { STATUS } from 'modules/companyEmployee'

export const viewerFragment = `
  name
  profileImage
`

export const signupViewerFragment = `
  name
  profileImage
  id
  username
  email
  contact {
    familyName
    givenName
  }
`

export const ownerFragment = `
  id
  username
  profileImage
  name
  corpName
`

export const roomFragment = `
  id
  uid
  name
  capacity
  hasDirectReservationPlans
  hasLastMinuteDiscountPlans
  prices {
    minText
    minUnitText
    maxText
    maxUnitText
  }
  thumbnails(perPage: 1) {
    results {
      url
      description
    }
  }
  space {
    username
    state
    stateText
    city
  }
  owner {
    rank
  }
`

export const pageInfoFragment = `
  totalCount
  resultsCount
  totalPages
  currentPage
  hasNextPage
  hasPreviousPage
  nextPage
  previousPage
`

export const companyEmployeeFragment = `
  id
  companyId
  email
  role
  name
  profileImage
  status
`

export const featureFragment = `
  id
  uid
  title
  description
  image
`

export const companyBaseFragment = `
  id
  name
  username
  profileImage
  paymentMethod
  paymentMethodText
  hasConfirmedPhone
`

export const companyFragment = `
  ${companyBaseFragment}
  employees {
    pageInfo {
      totalCount
    }
  }
`

export const companyEmployeeListFragment = `
  ${companyBaseFragment}
  employees(status: ${STATUS.VERIFIED}, page: $page, perPage: $perPage) {
    results {
      ... on CompanyEmployee {
        ${companyEmployeeFragment}
      }
    }
    pageInfo {
      ${pageInfoFragment}
    }
  }
  invitedEmployees: employees(status: ${
    STATUS.INVITED
  }, page: $page, perPage: $perPage) {
    results {
      ... on CompanyEmployee {
        ${companyEmployeeFragment}
      }
    }
    pageInfo {
      ${pageInfoFragment}
    }
  }
`

export const companySettingFragment = `
  id
  name
  corpNameKana
  username
  profileImage(isShowAltImage: false)
  paymentMethod
  paymentMethodText
  username
  postalCode
  state
  stateText
  city
  address1
  address2
  email
  tel
  contactPersonFamilyName
  contactPersonGivenName
  contactPersonFamilyNameKana
  contactPersonGivenNameKana
  department
  email
  department
  businessTaxId
  ceoFamilyName
  ceoGivenName
  ceoFamilyNameKana
  ceoGivenNameKana
  selectedPaymentId
  hasConfirmedPhone
  employees {
    pageInfo {
      totalCount
    }
  }
  paidCustomer {
    id
    status
  }
`

export const companyPaymentFragment = `
  id
  last4
  name
  type
  expMonth
  expYear
`

export const userErrorsFragment = `
  field
  resource
  message
`

export const companyQuestionFragment = `
  id
  title
  description
  isRequired
  isVisible
  companyId
  example
`
